import { render, staticRenderFns } from "./DoubleParameter.vue?vue&type=template&id=1c874594&"
import script from "./DoubleParameter.vue?vue&type=script&lang=ts&"
export * from "./DoubleParameter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports